import React from "react";
import "./styles.scss";

const FileCardButton = ({ children, onClick, width }) => {
  return (
    <div 
      className="file-card-button" 
      onClick={onClick} 
      style={width ? { width } : {}}
    >
      {children}
    </div>
  );
};

export default FileCardButton;
